module.exports = __webpack_public_path__ + "static/media/Character1_Trousers.2df0d0de.svg";